module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CRspace"
  }, [_vm._v("Copyright © 1978, 1979 by Jim Harrison")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace"
  }, [_vm._v("Cover design by Charles Rue Woods")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("Artwork by Russell Chatham")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-5"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove Atlantic, 154 West 14th Street, "), _c('br'), _vm._v("New York, NY 10011 or permissions@groveatlantic.com.")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-5"
  }, [_vm._v("The lines from “Gacela of the Dark Death” (translated by Stephen Spender and J. L. Gili), “Casida of the Reclining Woman” (translated by W. S. Merwin) and “The Faithless Wife” (translated by Stephen Spender and J. L. Gili) are from "), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("The Selected Poems of Federico Garcia Lorca,")]), _vm._v(" translated by Stephen Spender, J. L. Gili and W. S. Merwin. Copyright © 1955 by New Directions Publishing Corporation. Reprinted by permission of New Directions.")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-5"
  }, [_vm._v("The publisher also notes that the lines quoted from Olive Beaupré Miller’s "), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("My Book House")]), _vm._v(" anthology on p. 122 are quoting Robert Louis Stevenson.")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-5"
  }, [_vm._v("The novella "), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Legends of the Fall")]), _vm._v(" and a shorter version of "), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Revenge")]), _vm._v(" first appeared in "), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Esquire")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-5"
  }, [_vm._v("First Grove Atlantic edition, July 2016 ")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-5"
  }, [_vm._v("ISBN 978-8021-2622-1")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-6"
  }, [_vm._v("eISBN 978-0-8021-9221-9")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-5"
  }, [_vm._v("Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("an imprint of Grove Atlantic")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("154 West 14th Street")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-7"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "CRspace ParaOverride-7"
  }, [_vm._v("groveatlantic.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11cdf1e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V4481_eBook3.vue
// module id = 72
// module chunks = 0